/**
 * Replay buffer so React Strict Mode remounts can re-read after sessionStorage
 * was cleared by a one-shot take on the full-screen editor.
 */
const takenReplay = { value: undefined as string | undefined };

export function repoMarkdownImportDraftStorageKey() {
  return "repo-markdown-import-draft";
}

function readRepoMarkdownImportDraft(): string {
  try {
    const raw = window.sessionStorage.getItem(
      repoMarkdownImportDraftStorageKey(),
    );
    return typeof raw === "string" ? raw : "";
  } catch {
    return "";
  }
}

/**
 * Read and clear the draft once (full-screen editor handoff).
 * Remounts within the same visit can replay the taken value.
 */
export function takeRepoMarkdownImportDraft(): string {
  if (takenReplay.value !== undefined) {
    return takenReplay.value;
  }

  const draft = readRepoMarkdownImportDraft();
  clearRepoMarkdownImportDraft();
  takenReplay.value = draft;
  return draft;
}

/**
 * Stash the repo URL when opening the full-screen editor from a landing page.
 * Do not call on every keystroke in the import toolbar.
 */
export function writeRepoMarkdownImportDraft(repoUrl: string) {
  try {
    const key = repoMarkdownImportDraftStorageKey();
    if (!repoUrl) {
      window.sessionStorage.removeItem(key);
      takenReplay.value = undefined;
      return;
    }
    window.sessionStorage.setItem(key, repoUrl);
    takenReplay.value = undefined;
  } catch {
    // sessionStorage may be unavailable (private mode / quota).
  }
}

export function clearRepoMarkdownImportDraft() {
  try {
    window.sessionStorage.removeItem(repoMarkdownImportDraftStorageKey());
  } catch {
    // Ignore storage failures when clearing.
  }
}

/** Reset take replay (tests only). */
export function resetRepoMarkdownImportDraftReplay(): void {
  takenReplay.value = undefined;
}
